import React from 'react'
import { connect } from 'react-redux'

import Step3View from './Step3View'

const Step3Instagram = ({ isFetching, currentTemplate, company, variables, options, templates, error }) => (
  <Step3View
    info={{
      name: 'Instagram Messenger',
      channel: 'Instagram',
    }}
    isFetching={isFetching}
    currentTemplate={currentTemplate}
    company={company}
    variables={variables}
    options={options}
    error={error}
    templates={templates}
  />
)

export default connect()(Step3Instagram)
